import Personalizer from 'personalizer';
import ConversionFactors from 'utils/personalizer/ConversionFactors';
import DistanceUnits from 'utils/personalizer/DistanceUnits';

var Conversion = {
    convertFahrenheitToCelsius: function(fValue) {
        fValue = parseFloat(fValue);
        return (fValue - 32) / 1.8;
    },

    getPaceFactor: function(unit) {
        var factor = 0;
        switch (unit) {
            case DistanceUnits.meter:
                factor = ConversionFactors.MinutesPerMeter;
                break;
            case DistanceUnits.yard:
                factor = ConversionFactors.MinutesPerYard;
                break;
            case DistanceUnits.mile:
                factor = ConversionFactors.MinutesPerMile;
                break;
            case DistanceUnits.kilometer:
                factor = ConversionFactors.MinutesPerKilometer;
                break;
            default:
                factor = 1;
                break;
        }
        return factor;
    },

    calculateSpeed: function(isMetric, distanceUnit, distance, elapsedTimeInSeconds) {
        var mps = Conversion.convertToMetersPerSecond(distanceUnit, distance, elapsedTimeInSeconds);
        var speed = null;
        if (isMetric) {
            speed = Conversion.metresPerSec2KMH(mps);
        } else {
            speed = Conversion.metresPerSec2MPH(mps);
        }
        speed = parseFloat(Personalizer.formatSpeed(speed));
        if (isMetric) {
            speed = speed * Conversion.ConversionFactors.KphToMps;
        } else {
            speed = speed * Conversion.ConversionFactors.MphToMps;
        }
        return speed;
    },

    convertPaceToSpeed: function(unit, minutesPerSecond) {
        var factor = this.getPaceFactor(unit);
        var value = 1.0 / minutesPerSecond;
        var result = value * factor;
        result = result * 10; // move decimal place over by 1
        return result;
    },

    convertDistance: function(distance, distanceUnit, distanceToUnit) {
        var conversionUnit = this.paceConversionUnit(distanceUnit, distanceToUnit);
        return distance * conversionUnit;
    },

    paceConversionUnit: function(distanceUnit, paceUnit) {
        var conversionUnit = 0;
        if (distanceUnit == paceUnit) {
            conversionUnit = 1;
        } else if (distanceUnit == DistanceUnits.mile && paceUnit == DistanceUnits.kilometer) {
            conversionUnit = ConversionFactors.MilesToKm;
        } else if (distanceUnit == DistanceUnits.mile && paceUnit == DistanceUnits.yard) {
            conversionUnit = ConversionFactors.MilesToYards;
        } else if (distanceUnit == DistanceUnits.mile && paceUnit == DistanceUnits.meter) {
            conversionUnit = ConversionFactors.MilesToMeters;
        } else if (distanceUnit == DistanceUnits.kilometer && paceUnit == DistanceUnits.yard) {
            conversionUnit = ConversionFactors.KmToYards;
        } else if (distanceUnit == DistanceUnits.kilometer && paceUnit == DistanceUnits.mile) {
            conversionUnit = ConversionFactors.KmToMiles;
        } else if (distanceUnit == DistanceUnits.kilometer && paceUnit == DistanceUnits.meter) {
            conversionUnit = ConversionFactors.KmToMeters;
        } else if (distanceUnit == DistanceUnits.meter && paceUnit == DistanceUnits.mile) {
            conversionUnit = ConversionFactors.MetersToMiles;
        } else if (distanceUnit == DistanceUnits.meter && paceUnit == DistanceUnits.kilometer) {
            conversionUnit = ConversionFactors.MetersToKm;
        } else if (distanceUnit == DistanceUnits.meter && paceUnit == DistanceUnits.yard) {
            conversionUnit = ConversionFactors.MetersToYards;
        } else if (distanceUnit == DistanceUnits.meter && paceUnit == DistanceUnits.nauticalMile) {
            conversionUnit = ConversionFactors.MetersToNauticalMiles;
        } else if (distanceUnit == DistanceUnits.yard && paceUnit == DistanceUnits.mile) {
            conversionUnit = ConversionFactors.YardsToMiles;
        } else if (distanceUnit == DistanceUnits.yard && paceUnit == DistanceUnits.kilometer) {
            conversionUnit = ConversionFactors.YardsToKm;
        } else if (distanceUnit == DistanceUnits.yard && paceUnit == DistanceUnits.meter) {
            conversionUnit = ConversionFactors.YardToMeters;
        } else if (distanceUnit == DistanceUnits.nauticalMile && paceUnit == DistanceUnits.meter) {
            conversionUnit = ConversionFactors.NauticalMilesToMeters;
        }
        return conversionUnit;
    },

    convertToMetersPerSecond: function(distanceUnit, distance, elapsedTimeInSeconds) {
        var meters = this.convertToMeters(distanceUnit, distance);
        var mps = meters / elapsedTimeInSeconds;
        return mps;
    },

    convertToMeters: function(distanceUnit, distance) {
        var meters = 0;
        switch (distanceUnit) {
            case DistanceUnits.mile:
                meters = distance * ConversionFactors.MilesToMeters;
                break;
            case DistanceUnits.kilometer:
                meters = distance * ConversionFactors.KmToMeters;
                break;
            case DistanceUnits.meter:
                meters = distance; // already in meters
                break;
            case DistanceUnits.yard:
                meters = distance * ConversionFactors.YardToMeters;
                break;
            case DistanceUnits.nauticalMile:
                meters = distance * ConversionFactors.NauticalMilesToMeters;
                break;
        }
        return meters;
    },

    convertSpeedToMPS: function(unit, value) {
        var factor = null;
        switch (unit) {
            case DistanceUnits.mile:
                factor = ConversionFactors.MphToMps;
                break;
            case DistanceUnits.kilometer:
                factor = ConversionFactors.KphToMps;
                break;
            case DistanceUnits.nauticalMile:
                factor = ConversionFactors.KnotsToMps;
                break;
            default:
                throw new Error('No conversion for ' + unit);
        }

        return factor * value;
    },

    metresPerSec2KMH: function(mps) {
        return mps * ConversionFactors.MpsToKph;
    },

    metresPerSec2MPH: function(mps) {
        return mps * ConversionFactors.MpsToMph;
    },

    convertToFloat: function(num, numberParser) {
        if (this.isNotEmpty(num)) {
            if (typeof num == 'string') {
                try {
                    num = numberParser.parse(num);
                } catch (err) {
                    num = 0;
                }
            }
        } else {
            num = null;
        }
        return num;
    },

    isNotEmpty: function(value) {
        return value != null && typeof value != 'undefined' && jQuery.trim(value).length > 0;
    }
};

Conversion.ConversionFactors = ConversionFactors;

export default Conversion;
